
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenRestorationMetricType {
    static readonly NORMALIZED_IMPACT: GenRestorationMetricType = new GenRestorationMetricType('NORMALIZED_IMPACT');
    static readonly RECOVERY_DURATION: GenRestorationMetricType = new GenRestorationMetricType('RECOVERY_DURATION');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'NORMALIZED_IMPACT') return GenRestorationMetricType.NORMALIZED_IMPACT;
        if (name === 'RECOVERY_DURATION') return GenRestorationMetricType.RECOVERY_DURATION;
        throw new Error('Unexpected value for GenRestorationMetricType:' + name);
    }

    static values(): GenRestorationMetricType[] {
        return [
            GenRestorationMetricType.NORMALIZED_IMPACT,
            GenRestorationMetricType.RECOVERY_DURATION,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

